import { createSelector } from '@ngrx/store';
import * as fromMobilityHubs from '../reducers/moblity-hub.reducer';
import { MobilityHub } from '../../../modules/mobility-hubs/interfaces';
import { selectRouteParams } from 'src/app/store/router';
import { AppState } from 'src/app/store/state';

export const selectMobilityHubState = (state: AppState) => state.mobilityHubs;

export const selectMobilityHubEntities = createSelector(
    selectMobilityHubState,
    fromMobilityHubs.getMobilityHubEntities
);

export const selectMobilityHubSupplies = createSelector(
    selectMobilityHubState,
    fromMobilityHubs.getMobilityHubSupplies
);

export const selectAllMobilityHubs = createSelector(
    selectMobilityHubEntities,
    (entities: { [id: string]: MobilityHub }) => {
        return Object.values(entities);
    }
);

export const selectAllMobilityHubSupplies = createSelector(
    selectMobilityHubSupplies,
    (entities: { [id: string]: any }) => {
        return Object.values(entities);
    }
);

export const selectMobilityHub = createSelector(
    selectMobilityHubEntities,
    selectRouteParams,
    (entities: { [id: string]: MobilityHub }, routeParams: any) => entities[routeParams.id]
);
